import { connect } from "react-redux"
import { Box, Divider, Paper, Tooltip } from "@mui/material"
import Towerimg from '../../assets/Images/electric-tower.svg'
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight'
import { useHistory } from 'react-router-dom'
import { useStyles } from './style'
import _ from "lodash"

const DashboardCard = (props) => {
  const classes = useStyles()
  const history = useHistory()
  const { currentUser } = props
  const isInstaller = currentUser && currentUser.is_installer
  const utility = props.utility || []

  const getProgramName = (text) => {
    if (text.length > 40) {
      text = text.substring(0, 40) + '...'
    }
    return text
  }

  const getInstallerProgramId = () => {
    const params = new URLSearchParams({ programs: props.program.map(obj => obj.id) })
    return params
  }

  return (
    <Box className={classes.cardWrapper} my={2} mx={3} onClick={() => isInstaller
      ? history.push(`/applications?${getInstallerProgramId()}`)
      : history.push({
        pathname: `/applicationlist/${_.get(props.program[0], 'id', '')}`,
      })}>
      <Paper elevation={2} classes={{ root: classes.paperRoot }}>
        <Box display="flex" py={2} px={1} alignItems="center" minHeight="65px">
          <Box display="flex" flexDirection="column" className={utility.length > 1 && classes.logoWrapper}>
            {utility.map(obj => <img src={obj.logo || Towerimg} className={obj.logo ? utility.length > 1 ? classes.multipleLogo : classes.utilityLogo : ''} style={{ verticalAlign: 'middle' }} alt="" />)}
          </Box>

          <Box className={classes.cardHeading} flexGrow="1">
            <Tooltip title={_.get(props.program[0], 'name', '')} placement="bottom-start">
              <Box>{getProgramName(_.get(props.program[0], 'name', ''))}</Box>
            </Tooltip>
          </Box>
          <KeyboardArrowRightIcon className={classes.cardIcon} color="primary" sx={{ height: 'auto' }} />
        </Box>
        <Divider />
        <Box px={3}>
          <Box display="flex" justifyContent="space-between" py={2}>
            <Box className={classes.cardKey}>Utility</Box>
            <Box className={classes.cardValue} display="flex" flexWrap="wrap">{_.map(utility, 'name').join(", ")}</Box>
          </Box>
          <Divider sx={{ color: '#707070', opacity: '0.3' }} />
          <Box display="flex" justifyContent="space-between" py={2}>
            <Box className={classes.cardKey}>Account</Box>
            <Box className={classes.cardValue} display="flex" flexWrap="wrap">{props.account}</Box>
          </Box>
          <Divider sx={{ color: '#707070', opacity: '0.3' }} />
          <Box display="flex" justifyContent="space-between" py={2} >
            <Box className={classes.cardKey}>State</Box>
            <Box className={classes.cardValue} display="flex" flexWrap="wrap">{[...new Set(_.map(utility, 'state'))].join(", ")}</Box>
          </Box>
        </Box>
      </Paper>
    </Box >
  )
}

const mapStateToProps = ({ auth }) => {
  const { currentUser } = auth
  return { currentUser }
}

export default connect(mapStateToProps, {})(DashboardCard)